import React from 'react';
import {Table} from '../../../../components/table/Table';
import {TableHeader} from '../../../../components/table/Headers';
import {
  AddButton,
  BorderLessButton,
} from '../../../../components/button/AddButton';

import {useLeftMenuContext} from '../../../../components/menu/LeftMenuContext';
import {Text} from '@unthinkable/react-core-components';
import {useTheme} from '@unthinkable/react-theme';

export const ProjectLibraryTable = ({
  route: {params},
  navigation,
  libraryType,
  title,
}) => {
  const {navigateTo} = useLeftMenuContext() || {};
  const {icons} = useTheme();
  const {project_id} = params;

  const {breadcrumb, ...rest} = params;

  return (
    <Table
      eventSourceId="Library"
      api={`/projects/${project_id}/libraries`}
      filter={{
        type: libraryType,
      }}
      renderHeader={props => {
        let {data} = props;
        const importedLibraryIds = data?.map(_data => {
          return _data?._id;
        });
        return (
          <TableHeader
            title={title}
            actions={[
              <BorderLessButton
                onPress={() => {
                  navigation.navigate('import-libraries', {
                    libraryType,
                    importedLibraryIds,
                    ...params,
                  });
                }}
                text={'Import'}
                icon={icons.DownloadBlue}
              />,
              <AddButton
                title={'Library'}
                view="add-library"
                params={{...params, libraryType, title}}
              />,
            ]}
          />
        );
      }}
      onRowPress={({row}) => {
        navigateTo('library-detail', {
          ...params,
          projectlibrary: row,
          projectlibrary_id: row?._id,
          libraryType,
          integratedProject: row.integrated_project,
          breadcrumb: {
            dropdown: {
              field: 'projectlibrary',
            },
          },
        });
      }}
      columns={[
        {
          header: 'Name',
          field: 'name',
          type: 'text',
        },
        {
          header: 'Repository',
          field: 'repository_id.repository',
          type: 'text',
          width: 200,
        },
        {
          header: 'Language',
          field: 'language',
          type: 'text',
          width: 200,
        },
        {
          header: 'Framework',
          field: 'framework',
          type: 'text',
          width: 200,
        },
        {
          align: 'right',
          width: 80,
          header: 'Version',
          render: ({row, styles}) => {
            let {latest_version_id, integrated_project} = row || {};
            if (!latest_version_id) {
              return;
            }
            let version =
              integrated_project?.library_version_id?.version ||
              latest_version_id.version;
            return <Text style={styles?.rowText}>{version}</Text>;
          },
        },
      ]}
      moreActions={[
        {
          title: 'Edit',
          onPress: ({row}) => {
            navigation.navigate('edit-library', {
              ...params,
              title,
              row,
            });
          },
          visible: ({row}) => row?.project_id === project_id,
        },
        {
          title: 'Publish',
          onPress: ({row}) => {
            navigation.navigate('publish-library', {
              ...params,
              row,
            });
          },
          visible: ({row}) => row?.project_id === project_id,
        },
        {
          title: 'Clone Library',
          onPress: ({row}) => {
            navigation.navigate('import-libraries', {
              library: row,
              libraryType,
              clone: true,
              ...params,
            });
          },
          visible: ({row}) => row?.project_id === project_id,
        },
        {
          title: 'Update Version',
          onPress: ({row}) => {
            let libraryVersion = row.integrated_project?.library_version_id;
            navigation.navigate('change-integrated-project-library-version', {
              ...rest,
              libraryVersion,
              row,
            });
          },
          visible: ({row}) => row?.project_id !== project_id,
        },
        {
          title: 'All Versions',
          onPress: ({row}) => {
            navigation.navigate('project-library-versions', {
              ...rest,
              row,
            });
          },
          visible: ({row}) => row?.library_version_count > 0,
        },
      ]}
    />
  );
};
